export const KEYWORDS = [
  '养老',
  '公积金',
  '数字政务',
  '政府基金',
  '中国烟草',
  '烟草服务银行',
  '江苏省国资委',
  '江苏机关事务'
];

export const KEYWORD_COLORS = {
  '养老': '#2f8f83',
  '公积金': '#256f93',
  '数字政务': '#3b8f9f',
  '政府基金': '#203547',
  '中国烟草': '#5f8f4e',
  '烟草服务银行': '#8a6f2a',
  '江苏省国资委': '#c58b2b',
  '江苏机关事务': '#526d99'
};
